<ra-modal [title]="('document.edit.createTemplate.title' | translate)" (close)="close.emit()">

    <p class="ra-label-s content-secondary">{{ 'document.edit.createTemplate.intro' | translate }}</p>

    <div class="form-group" [formGroup]="formGroup">

        <ra-input 
            formControlName="title"
            [label]="('document.edit.createTemplate.templateDescriptionLabel' | translate)" 
            [placeholder]="('document.edit.createTemplate.templateDescriptionPlaceholder' | translate)" 
        />

        <ra-checkbox 
            formControlName="sessions"
            [label]="('document.edit.createTemplate.sessionsCopied' | translate)" 
        />
        
        <ra-checkbox 
            formControlName="allFieldsNeedSave"
            [label]="('document.edit.createTemplate.allFieldsCopied' | translate)" 
        />
    </div>

    <div class="modal-actions">
        <ra-button
            [label]="'common.cancel' | translate"
            [type]="'primary-outline'"
            [disabled]="loading()"
            (click)="onCancel()">
        </ra-button>

        <ra-button
            [label]="'common.save' | translate"
            [type]="'primary'"
            [disabled]="formGroup.invalid || loading()"
            [loading]="loading()"
            (click)="createTemplate()">
        </ra-button>
    </div>
</ra-modal>
